export const NEW_TRANSACTION = 'NEW_TRANSACTION';
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION';